// src/components/MachineDetailView/MachineDetail.jsx
import React, {useMemo} from "react";
import {useParams} from "react-router-dom";
import MachineDetailHeader from "./MachineDetailHeader";
import ShiftWrapper from "./ShiftWrapper";
import {useMachineDetail} from "../../hooks/useMachineDetail";
import "../../App.css";

function MachineDetail() {
  const {machineSerialNumber} = useParams();

  const todayDate = useMemo(() => new Date().toISOString().split("T")[0], []);

  const {machine, loading} = useMachineDetail(machineSerialNumber, todayDate);

  if (loading) return <div>Loading...</div>;
  if (!machine) return <div>Machine not found with serial number {machineSerialNumber}</div>;

  return (
    <div>
      <MachineDetailHeader machineName={machine.name} date={todayDate} workMode={machine.shiftModel || "-"} />

      <ShiftWrapper machine={machine} hours={machine.hours} shifts={machine.shifts || []} colorConfig={machine.colorConfig} />
    </div>
  );
}

export default MachineDetail;
